<template>
  <div :class="$style.current_panel">
    <columns-bar-header
      :title="locales('columns_bar_current_title')"
      :view-config="viewConfig"
      :tabs="tabs"
      :back-button="false"
      :help-button="true"
      @onChangeTab="changeTab"
      @onClose="onClose"
      @helpIconClick="helpIconClick"
    />
    <component
      :is="currentComponent"
      :key="currentComponent"
      :columns="columns"
      :focused-column-id="viewConfig.focusedColumnId"
      :is-editable="viewConfig.editable"
      :is-archived="!!viewConfig.isArchivedProject"
      @onCreateNewColumnClick="$emit('onCreateNewColumnClick')"
      @onUseExistedColumnClick="$emit('onUseExistedColumnClick')"
      @openEditBar="data => $emit('openEditBar', data)"
      @onDeleteClick="data => $emit('onDeleteClick', data)"
      @changeCheckbox="changeCheckbox"
      @changeCheckboxOption="data => $emit('changeCheckboxOption', data)"
      @redirectToSettings="$emit('redirectToSettings')"
      @showGradient="showGradient"
    />
    <gradient :show="isShowGradient && currentComponent === 'standartColumns'" />
  </div>
</template>

<script>
import columnsBarHeader from '../components/header/index.vue';
import standartColumns from '../components/standartColumnsTab/standartColumnsTab.vue';
import customColumns from '../components/customColumnsTab/customColumnsTab.vue';
import gradient from '../components/gradient/gradient.vue';

export default {
  name: 'ColumnsBarColumnsView',
  components: {
    columnsBarHeader, standartColumns, customColumns, gradient,
  },
  props: {
    viewConfig: { type: Object, required: true, default: () => {} },
  },
  emits: {
    onClose: null,
    onCreateNewColumnClick: null,
    onUseExistedColumnClick: null,
    openEditBar: Object,
    onDeleteClick: Object,
    helpIconClick: Object,
    changeCheckbox: Object,
    changeView: String,
    changeCheckboxOption: Object,
    redirectToSettings: null,
  },
  data() {
    return {
      locales: __,
      columns: [],
      currentComponent: null,
      selected: [],
      tabs: [
        {
          type: 'standartColumns',
          title: __('columns_bar_standart_columns_tab'),
          width: 125,
        },
        {
          type: 'customColumns',
          title: __('columns_bar_custom_columns_tab'),
          width: 125,
        },
      ],
      isShowGradient: true,
    };
  },
  watch: {
    'viewConfig.activeTab': {
      handler(activeTab) {
        this.currentComponent = activeTab;
        this.isShowGradient = true;
      },
      immediate: true,
    },
    'viewConfig.columns': {
      handler(configColumns) {
        if (configColumns && this.currentComponent in configColumns) {
          this.columns = configColumns[this.currentComponent];
        }
      },
      deep: true,
      immediate: true,
    },
  },
  beforeUnmount() {
    this.selected = [];
    this.isShowGradient = true;
  },
  created() {},
  methods: {
    changeTab(obj) {
      this.currentComponent = obj.type;
      this.$emit('changeView', null, obj.type);

      if (obj.type === 'customColumns') {
        userExtAnalytics.log('columns_sidebar_custom_columns_tab');
      } else {
        userExtAnalytics.log('columns_sidebar_standart_columns_tab');
      }
    },
    onClose() {
      this.$emit('onClose');
    },
    changeCheckbox(data) {
      this.$emit('changeCheckbox', data);
    },
    showGradient(flag) {
      this.isShowGradient = flag;
    },
    helpIconClick(e) {
      let id;

      if (this.currentComponent === 'standartColumns') {
        id = 'columnsSidebarStandartColumns';
      } else {
        id = 'columnsSidebarCustomColumns';
      }
      this.$emit('helpIconClick', {
        event: e,
        id,
      });
    },
  },
};
</script>

<style module lang='less'>
.current_panel {
  position: relative;
  background-color: #ffffff;
  box-shadow: -20px 0px 22px -22px rgba(0, 0, 0, 0.2);
}
</style>
